import { Swiper as ReactSwiper, SwiperSlide } from 'swiper/react'
import Swiper from 'swiper'
import { t } from 'i18next'
import { FC } from 'react'

import { StepResult } from '../../../types/Result'
import InteractionBase from '../../../common/components/InteractionBase'
import { getResultComponent } from '../../../common/utils/result'
import StepsNavigation from '../../../common/components/InteractionBase/StepsNavigation'
import { useFeedStore } from '../../../store/feed-store'
import { Translatable } from '../../../common/types/translatable'
import { getDetectedLanguage } from '../../../i18n'

interface MultipleStepsProps {
  title: Translatable
  results: StepResult[]
}

// TODO: Create hook for setting current step
const MultipleResults: FC<MultipleStepsProps> = ({ results, title }) => {
  const { setCurrentStep } = useFeedStore()

  const handleSlideChange = (swiper: Swiper) => {
    setCurrentStep(swiper.activeIndex + 1)
  }

  const hasStepDisplay = results.length > 1

  return (
    <>
      <ReactSwiper
        className="mySwiper"
        spaceBetween={30}
        style={{ height: '100%' }}
        onSlideChange={handleSlideChange}
      >
        {hasStepDisplay && <StepsNavigation numberOfSteps={results.length} />}
        {results.map((result, index) => (
          <SwiperSlide key={index} style={{ height: '100%' }}>
            <InteractionBase
              title={title[getDetectedLanguage()]}
              subtitle={t('results.reflection')}
              hasStepDisplay={hasStepDisplay}
            >
              {getResultComponent(result)}
            </InteractionBase>
          </SwiperSlide>
        ))}
      </ReactSwiper>
    </>
  )
}

export default MultipleResults
